module.exports = __webpack_public_path__ + "img/site_logo.a3bb9096.png";